import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { resetProductSelection } from '/@/store/catalog/actions';
import { getCatalogBrands } from '/@/store/catalog/selectors';
import { reverse } from '/@/utils/router';

// V3 Components
import BaseBrandSelection from '/@/v3/components/brand-selection';

const BrandSelection = () => {
    const brands = useSelector(getCatalogBrands);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (brands.length === 1) {
            const { type, slug } = brands[0];
            dispatch(bindActionCreators(resetProductSelection, dispatch));
            return navigate(
                reverse('catalog.ProductSelection', {
                    params: { type, slug },
                })
            );
        }
    }, []);

    const handleClick = (type, slug) => {
        dispatch(bindActionCreators(resetProductSelection, dispatch));
        navigate(
            reverse('catalog.ProductSelection', {
                params: { type, slug },
            })
        );
    };

    return <BaseBrandSelection brands={brands} onClick={handleClick} />;
};

export default BrandSelection;
